import { useNavigate } from "@tanstack/react-router";
import { captureEvent } from "../../../../utils/posthog";
import { useCallback } from "react";
import { Event } from "../../../../constants/events";

export const useNavigateTileset = () => {
  const navigate = useNavigate();

  return useCallback((accountName: string, tileset: string, dataset?: string) => {
    if (!dataset) {
      captureEvent(Event.TilesetNavigateToOverview, {
        tileset,
      });
      void navigate({
        to: "/$accountName/tilesets/$tileset/overview",
        params: { tileset, accountName },
      });
    }
    else {
      captureEvent(Event.TilesetDatasetNavigateToOverview, {
        tileset,
        dataset,
      });
      void navigate({
        to: "/$accountName/tilesets/$tileset/overview",
        params: { tileset, accountName },
        search: { dataset },
      });
    }
  }, [navigate]);
};
